import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './Assets/Fonts/SFPro/SFProDisplay-Regular.ttf'
import './Assets/Fonts/SFPro/SFProDisplay-Ultralight.ttf'
import './Assets/Fonts/SFPro/SFProDisplay-Heavy.ttf'
import './Assets/Fonts/SFPro/SFProDisplay-Bold.ttf'
import './Assets/Fonts/SFPro/SFProDisplay-Thin.ttf'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
